import { useRef } from "react";
import { atom, useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import AttentionDialog from "./attention_dialog";
import { useLocation } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Normalize, NormalizeKana } from '../../static/js/normalize';
import Maintenance from "./maintenance";

const kubunAtom = atom();
const expAtom = atom();
const nasAtom = atom();
const hciAtom = atom();
const swAtom = atom();
const etcAtom = atom();
const productsServiceAtom = atom();
const osAtom = atom();
const titleAtom = atom();
const detailAtom = atom();
const youtoAtom = atom();
const releaseAtom = atom();
const yosanAtom = atom();
const cnameAtom = atom();
const sectionAtom = atom();
const nameAtom = atom();
const kenAtom = atom();
const addressAtom = atom();
const tel1Atom = atom();
const tel2Atom = atom();
const tel3Atom = atom();
const emailAtom = atom();
const email2Atom = atom();
const ecnameAtom = atom();
const esectionAtom = atom();
const enameAtom = atom();
const etelAtom = atom();
const eemailAtom = atom();

const openAttentionDialogAtom = atom({ show: false, dialogId: 0 });

function MainComponent({ handleLoading }) {

    document.title = "ファーストコンタクトセンター | NEC";
    const imageUrlPopUp = require("../../images/popup.png")
    const imageUrlBlank = require("../../images/_blank.png")
    const navigate = useNavigate();
    const location = useLocation();

    const [kubun, setKubun] = useAtom(kubunAtom);
    const [exp, setExp] = useAtom(expAtom);
    const [nas, setNas] = useAtom(nasAtom);
    const [hci, setHci] = useAtom(hciAtom);
    const [sw, setSw] = useAtom(swAtom);
    const [etc, setEtc] = useAtom(etcAtom);
    const [productsService, setProductsService] = useAtom(productsServiceAtom);
    const [os, setOs] = useAtom(osAtom);
    const [title, setTitle] = useAtom(titleAtom);
    const [detail, setDetail] = useAtom(detailAtom);
    const [youto, setYouto] = useAtom(youtoAtom);
    const [release, setRelease] = useAtom(releaseAtom);
    const [yosan, setYosan] = useAtom(yosanAtom);
    const [cname, setCname] = useAtom(cnameAtom);
    const [section, setSection] = useAtom(sectionAtom);
    const [name, setName] = useAtom(nameAtom); 
    const [ken, setKen] = useAtom(kenAtom);
    const [address, setAddress] = useAtom(addressAtom);
    const [tel1, setTel1] = useAtom(tel1Atom);
    const [tel2, setTel2] = useAtom(tel2Atom);
    const [tel3, setTel3] = useAtom(tel3Atom);
    const [email, setEmail] = useAtom(emailAtom); 
    const [email2, setEmail2] = useAtom(email2Atom); 
    const [ecname, setEcname] = useAtom(ecnameAtom); 
    const [esection, setEsection] = useAtom(esectionAtom); 
    const [ename, setEname] = useAtom(enameAtom); 
    const [etel, setEtel] = useAtom(etelAtom); 
    const [eemail, setEemail] = useAtom(eemailAtom); 

    const [openAttentionDialog, setOpenAttentionDialog] = useAtom(openAttentionDialogAtom);
    const { register, formState: { errors }, handleSubmit, clearErrors, reset, setValue } = useForm({ shouldFocusError: false });
    
    const kubunRef = useRef(null);
    const detailRef = useRef(null);
    const youtoRef = useRef(null);
    const releaseRef = useRef(null);
    const cnameRef = useRef(null);
    const nameRef = useRef(null);
    const addressRef = useRef(null);
    const tel1Ref = useRef(null);
    const tel2Ref = useRef(null);
    const tel3Ref = useRef(null);
    const emailRef = useRef(null);
    const email2Ref = useRef(null);

    const onSubmit = (data) => {
        buttonRegist();
    }

    if (exp === undefined) {
        setExp(false);
    }
    if (nas === undefined) {
        setNas(false);
    }
    if (hci === undefined) {
        setHci(false);
    }
    if (sw === undefined) {
        setSw(false);
    }
    if (etc === undefined) {
        setEtc(false);
    }
    if (yosan === undefined) {
        setYosan("～100万円");
    }
    if (ken === undefined) {
        setKen("東京都");
    }
    if (!location.state) {
        location.state = { page: false };
    }
    function initInput() {
        setKubun(location.state.kubun);
        setValue("kubun", location.state.kubun);
        setExp(location.state.exp);
        setValue("exp", location.state.exp);
        setNas(location.state.nas);
        setValue("nas", location.state.nas);
        setHci(location.state.hci);
        setValue("hci", location.state.hci);
        setSw(location.state.sw);
        setValue("sw", location.state.sw);
        setEtc(location.state.etc);
        setValue("etc", location.state.etc);
        setProductsService(location.state.productsService);
        setValue("productsService", location.state.productsService);
        setOs(location.state.os);
        setValue("os", location.state.os);
        setTitle(location.state.title);
        setValue("title", location.state.title);
        setDetail(location.state.detail);
        setValue("detail", location.state.detail);
        setYouto(location.state.youto);
        setValue("youto", location.state.youto);
        setRelease(location.state.release);
        setValue("release", location.state.release);
        setYosan(location.state.yosan);
        setValue("yosan", location.state.yosan);
        setCname(location.state.cname);
        setValue("cname", location.state.cname);
        setSection(location.state.section);
        setValue("section", location.state.section);
        setName(location.state.name);
        setValue("name", location.state.name);
        setKen(location.state.ken);
        setValue("ken", location.state.ken);
        setAddress(location.state.address);
        setValue("address", location.state.address);
        setTel1(location.state.tel1);
        setValue("tel1", location.state.tel1);
        setTel2(location.state.tel2);
        setValue("tel2", location.state.tel2);
        setTel3(location.state.tel3);
        setValue("tel3", location.state.tel3);
        setEmail(location.state.email);
        setValue("email", location.state.email);
        setEmail2(location.state.email2);
        setValue("email2", location.state.email2);
        setEcname(location.state.ecname);
        setValue("ecname", location.state.ecname);
        setEsection(location.state.esection);
        setValue("esection", location.state.esection);
        setEname(location.state.ename);
        setValue("ename", location.state.ename);
        setEtel(location.state.etel);
        setValue("etel", location.state.etel);
        setEemail(location.state.eemail);
        setValue("eemail", location.state.eemail);
        location.state.page = false
    }
    if (location.state.page === true) {
        clearErrors();
        initInput();
    }

    const handleKubunChange = (event) => {
        setKubun(event.target.value);
        setValue("kubun", event.target.value);
        clearErrors();
    };
    const handleExpChange = (event) => {
        setExp(event.target.checked);
        setValue("exp", event.target.checked);
        clearErrors();
    };
    const handleNasChange = (event) => {
        setNas(event.target.checked);
        setValue("nas", event.target.checked);
        clearErrors();
    };
    const handleHciChange = (event) => {
        setHci(event.target.checked);
        setValue("hci", event.target.checked);
        clearErrors();
    };
    const handleSwChange = (event) => {
        setSw(event.target.checked);
        setValue("sw", event.target.checked);
        clearErrors();
    };
    const handleEtcChange = (event) => {
        setEtc(event.target.checked);
        setValue("etc", event.target.checked);
        clearErrors();
    };
    const handleProductsServiceChange = (event) => {
        setProductsService(event.target.value);
        setValue("ProductsService", event.target.value);
        clearErrors();
    };
    const handleOsChange = (event) => {
        setOs(event.target.value);
        setValue("os", event.target.value);
        clearErrors();
    };
    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        setValue("title", event.target.value);
        clearErrors();
    };
    const handleDetailChange = (event) => {
        setDetail(event.target.value);
        setValue("detail", event.target.value);
        clearErrors();
    };
    const handleYoutoChange = (event) => {
        setYouto(event.target.value);
        setValue("youto", event.target.value);
        clearErrors();
    };
    const handleReleaseChange = (event) => {
        setRelease(event.target.value);
        setValue("release", event.target.value);
        clearErrors();
    };
    const handleYosanChange = (event) => {
        setYosan(event.target.value);
        setValue("yosan", event.target.value);
        clearErrors();
    };
    const handleCnameChange = (event) => {
        setCname(event.target.value);
        setValue("cname", event.target.value);
        clearErrors();
    };
    const handleSectionChange = (event) => {
        setSection(event.target.value);
        setValue("section", event.target.value);
        clearErrors();
    };
    const handleKenChange = (event) => {
        setKen(event.target.value);
        setValue("ken", event.target.value);
        clearErrors();
    };
    const handleAddressChange = (event) => {
        setAddress(event.target.value);
        setValue("address", event.target.value);
        clearErrors();
    };
    const handleTel1Change = (event) => {
        setTel1(event.target.value);
        setValue("tel1", event.target.value);
        clearErrors();
    };
    const handleTel2Change = (event) => {
        setTel2(event.target.value);
        setValue("tel2", event.target.value);
        clearErrors();
    };
    const handleTel3Change = (event) => {
        setTel3(event.target.value);
        setValue("tel3", event.target.value);
        clearErrors();
    };
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setValue("email", event.target.value);
        clearErrors();
    };
    const handleEmail2Change = (event) => {
        setEmail2(event.target.value);
        setValue("email2", event.target.value);
        clearErrors();
    };
    const handleEcnameChange = (event) => {
        setEcname(event.target.value);
        setValue("ecname", event.target.value);
        clearErrors();
    };
    const handleEsectionChange = (event) => {
        setEsection(event.target.value);
        setValue("esection", event.target.value);
        clearErrors();
    };
    const handleNameChange = (event) => {
        setName(event.target.value);
        setValue("name", event.target.value);
        clearErrors();
    };
    const handleEnameChange = (event) => {
        setEname(event.target.value);
        setValue("ename", event.target.value);
        clearErrors();
    };
    const handleEtelChange = (event) => {
        setEtel(event.target.value);
        setValue("etel", event.target.value);
        clearErrors();
    };
    const handleEemailChange = (event) => {
        setEemail(event.target.value);
        setValue("eemail", event.target.value);
        clearErrors();
    };

    const handleProductsServiceNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setProductsService(event.target.value);
        setValue("ProductsService", event.target.value);
        clearErrors();
    }
    const handleOsNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setOs(event.target.value);
        setValue("os", event.target.value);
        clearErrors();
    }
    const handleTitleNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setTitle(event.target.value);
        setValue("title", event.target.value);
        clearErrors();
    }
    const handleDetailNormalize = (event) => {
        event.target.value = NormalizeKana(event.target.value);;
        setDetail(event.target.value);
        setValue("detail", event.target.value);
        clearErrors();
    }
    const handleCnameNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setCname(event.target.value);
        setValue("cname", event.target.value);
        clearErrors();
    }
    const handleSectionNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setSection(event.target.value);
        setValue("section", event.target.value);
        clearErrors();
    }
    const handleNameNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setName(event.target.value);
        setValue("name", event.target.value);
        clearErrors();
    }
    const handleAddressNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setAddress(event.target.value);
        setValue("address", event.target.value);
        clearErrors();
    }
    const handleTel1Normalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setTel1(event.target.value);
        setValue("tel1", event.target.value);
        clearErrors();
    }
    const handleTel2Normalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setTel2(event.target.value);
        setValue("tel2", event.target.value);
        clearErrors();
    }
    const handleTel3Normalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setTel3(event.target.value);
        setValue("tel3", event.target.value);
        clearErrors();
    }
    const handleEmailNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEmail(event.target.value);
        setValue("email", event.target.value);
        clearErrors();
    }
    const handleEmail2Normalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEmail2(event.target.value);
        setValue("email2", event.target.value);
        clearErrors();
    }
    const handleEcnameNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEcname(event.target.value);
        setValue("ecname", event.target.value);
        clearErrors();
    }
    const handleEsectionNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEsection(event.target.value);
        setValue("esection", event.target.value);
        clearErrors();
    }
    const handleEnameNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEname(event.target.value);
        setValue("ename", event.target.value);
        clearErrors();
    }
    const handleEtelNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEtel(event.target.value);
        setValue("etel", event.target.value);
        clearErrors();
    }

    const handleEemailNormalize = (event) => {
        event.target.value = Normalize(event.target.value);;
        setEemail(event.target.value);
        setValue("eemail", event.target.value);
        clearErrors();
    }

    const handleClose = (newValue, id) => {
        setOpenAttentionDialog({ show: false });
    };

    const checkErrorIsExist = () => {
        return Object.keys(errors).length > 0;
    }

    const checkErrors = (errors) => {
        console.log(Object.keys(errors));
        console.log(errors);
        if (errors.kubun?.message) {
            alert(errors.kubun?.message);
            kubunRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.detail?.message) {
            alert(errors.detail?.message);
            detailRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.youto?.message) {
            alert(errors.youto?.message);
            youtoRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.release?.message) {
            alert(errors.release?.message);
            releaseRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.cname?.message) {
            alert(errors.cname?.message);
            cnameRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.name?.message) {
            alert(errors.name?.message);
            nameRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.address?.message) {
            alert(errors.address?.message);
            addressRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.tel1?.message) {
            alert(errors.tel1?.message);
            tel1Ref.current.focus();
            clearErrors();
            return;
        }
        if (errors.tel2?.message) {
            alert(errors.tel2?.message);
            tel2Ref.current.focus();
            clearErrors();
            return;
        }
        if (errors.tel3?.message) {
            alert(errors.tel3?.message);
            tel3Ref.current.focus();
            clearErrors();
            return;
        }
        if (errors.email?.message) {
            if (email !== undefined && (email.startsWith("@") || email.endsWith("@"))) {
                alert("有効なE-Mailアドレスではありません (@の位置)");
            } else {
                alert(errors.email?.message);
            }
            emailRef.current.focus();
            clearErrors();
            return;
        }
        if (errors.email2?.message) {
            alert(errors.email2?.message);
            email2Ref.current.focus();
            clearErrors();
            return;
        }
    }

    const buttonRegist = () => {
    
        if (email !== email2) {
            alert("入力したE-Mailアドレスが一致しません。");
            return;
        }
        navigate("/contact_confirm", {
            state: {
                kubun: kubun,
                exp: exp,
                nas: nas,
                hci: hci,
                sw: sw,
                etc: etc,
                productsService: productsService,
                os: os,
                title: title,
                detail: detail,
                youto: youto,
                release: release,
                yosan: yosan,
                cname: cname,
                section: section,
                name: name,
                ken: ken,
                address: address,
                tel1: tel1,
                tel2: tel2,
                tel3: tel3,
                email: email,
                email2: email2,
                ecname: ecname,
                esection: esection,
                ename: ename,
                etel: etel,
                eemail: eemail,
                page: true
            }
        });
    }

    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">

                <div className="str-inner">

                    <h2 className="mod-hdg-l2-02">
                        <span>Express5800シリーズ・iStorageシリーズ お問い合わせ</span>
                    </h2>
                    <strong>
                        Express5800シリーズ、iStorageシリーズに関連するお問い合わせや、<br />
                        導入・購入におけるご相談を受け付けいたします。<br />
                        「お問い合わせ・ご相談にあたって」を確認のうえ、お問い合わせ内容をご入力ください。
                    </strong>

                    <h2 className="mod-hdg-l2-02">
                        <span>お問い合わせ・ご相談入力フォーム</span>
                    </h2>

                    <h4 className="mod-hdg-l4-02 mb-15">
                        <span>お問い合わせ・ご相談にあたって</span>
                    </h4>
                    <div className="mod-list mb-30">
                        <div className="mod-txt"><strong>
                            Express5800シリーズ、iStorageシリーズ および それらに関連する<br />
                            ソフトウェアやサービスについてお気軽にご相談ください。
                        </strong><br />
                        </div>
                        <ul className="list">
                            <li>
                                <div className="mod-txt">
                                    製品やサービスの仕様や機能を確認したい
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    構成・接続について相談したい
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    見積もりをとりたい
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    購入方法を知りたい
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    システム構成の助言が欲しい　など
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="mod-list mb-30">
                        <div className="mod-txt"><strong>
                            内容によっては回答できない場合がございますのでご了承ください。
                        </strong><br />
                        </div>
                        <ul className="list">
                            <li>
                                <div className="mod-txt">
                                    有償サービスの範囲に該当するお問い合わせ
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    他社製品との接続・動作、他社サービスに関して
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    技術教育、コンサルティング　など
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="mod-list mb-30">
                        <div className="mod-txt"><strong>
                            お問い合わせいただくにあたっては、必ず「<a style={{margin: "0px 0px 0px"}} href="#anc-attention">お問い合わせいただく前に</a>」の項をお読みください。<br />
                            また、これらにご了承のもとにお問い合わせをお願いいたします。
                        </strong><br />
                        </div>
                    </div>

                    <h4 className="mod-hdg-l4-02 mb-15">
                        <span>ご注意</span>
                    </h4>
                    <div className="mod-list mb-30">
                        <ul className="list">
                            <li>
                                <div className="mod-txt">
                                    <em>本ページは法人のお客様のみご利用ください。</em>
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    <em>本フォームではファイルを添付いただくことはできません。</em>
                                </div>
                            </li>
                            <li>
                                <div className="mod-txt">
                                    <em>販売店、NECグループの方は、以下からお問い合わせください。</em>
                                </div>
                                <br />
                                <a href="https://www.pb.nec.co.jp/product/info/express5800/contact" target="_blank">
                                    <img className="icn" lang="en" alt="new window" src={imageUrlBlank} />
                                    販売店・パートナー様はこちら
                                </a>
                                <br />
                                <a href="https://one.nec.com/info/express5800/contact" target="_blank">
                                    <img className="icn" lang="en" alt="new window" src={imageUrlBlank} />
                                    NECグループの方はこちら
                                </a>
                            </li>
                        </ul>
                    </div>
                    <form id="queryForm" name="queryForm">
                        <h3 className="mod-hdg-l2-02">
                            <span>お問い合わせ入力</span>
                        </h3>
                        <Maintenance />
                        <div className="mod-tbl-form">
                            <table role="presentation">
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">お問い合わせ・ご相談区分<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-radio">
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="kubun_question" name="kubun" value="1" checked={kubun === "1"} onChange={handleKubunChange} ref={kubunRef} />
                                                            <span
                                                                className="label">製品お問い合わせ</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="kubun_consultation" name="kubun" value="2" checked={kubun === "2"} onChange={handleKubunChange} />
                                                            <span
                                                                className="label">購入相談</span>
                                                        </label>
                                                    </li>
                                                    <input type="hidden" style={{ display: "none" }}  {...register("kubun", { required: "お問い合わせ・ご相談区分を選択してください。" })} />
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">お問い合わせ対象・ご検討機種</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-check">
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="checkbox" id="exp" name="exp" value="1" checked={exp} onChange={handleExpChange} />
                                                            <span className="label">Express5800シリーズ</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="checkbox" id="nas" name="nas" value="1" checked={nas} onChange={handleNasChange} />
                                                            <span className="label">iStorageシリーズ</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="checkbox" id="hci" name="hci" value="1" checked={hci} onChange={handleHciChange} />
                                                            <span className="label">ハイパーコンバージドインフラストラクチャ</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="checkbox" id="sw" name="sw" value="1" checked={sw} onChange={handleSwChange} />
                                                            <span className="label">ソフトウェア・サービス</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="checkbox" id="etc" name="etc" value="1" checked={etc} onChange={handleEtcChange} />
                                                            <span className="label">その他</span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>お問い合わせ製品・サービス</b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <p className="description">製品名・サービス名、モデル(型番)</p>
                                                <input type="text" id="productsService" name="productsService" maxLength="255" style={{ maxWidth: "95%" }}
                                                    placeholder="" value={productsService ? productsService : ""} onChange={handleProductsServiceChange} onBlur={handleProductsServiceNormalize} />
                                            </div>

                                            <div className="mod-input">
                                                <p className="description">OS</p>
                                                <input type="text" id="os" name="os" maxLength="255" style={{ maxWidth: "95%" }}
                                                    placeholder="" value={os ? os : ""} onChange={handleOsChange} onBlur={handleOsNormalize} />
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="title">件名</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="text" id="title" name="title" maxLength="100" style={{ maxWidth: "95%" }} value={title ? title : ""} 
                                                onChange={handleTitleChange} placeholder="100文字以内でご入力ください。" onBlur={handleTitleNormalize} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>お問い合わせ・ご相談内容<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <p className="description">ご検討中のシステム/サービス及び、用途について詳しくお聞かせください。</p>
                                                <p className="description">※既存のシステム環境、ご検討のシステム/サービス規模、ご予定の設置場所などについても、分かる範囲でご記入ください。</p>
                                                <br />
                                                <p className="description">件名、及び、お問い合わせの内容について、特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合は次ページの確認画面にてエラーとなる可能性がございます。</p>
                                                <p className="description">詳細は以下の「注意事項」をご参照ください。</p>
                                                <div className="description">
                                                    <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                        <span style={{ cursor: "pointer" }} onClick={() => { setOpenAttentionDialog({ show: true, dialogId: "attention" }); }}>
                                                            <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />
                                                            <span >注意事項</span>
                                                        </span>
                                                    </b>

                                                </div>
                                                {openAttentionDialog.show &&
                                                    <AttentionDialog
                                                        open={openAttentionDialog.show}
                                                        onClose={handleClose}
                                                        name={"注意事項"}
                                                    />}
                                                <textarea style={{ resize: "none" }} wrap="hard" rows="10" id="detail" name="detail"
                                                            maxLength="50000" placeholder="ご相談内容をご入力ください。" value={detail ? detail : ""} onChange={handleDetailChange}
                                                            ref={detailRef} onBlur={handleDetailNormalize} >
                                                        </textarea>

                                                <input type="text" style={{ display: "none" }} id="descriptionText"
                                                    {...register("detail", {
                                                        required: "お問い合わせ・ご相談内容を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "お問い合わせ・ご相談内容を入力してください。"
                                                        }
                                                    })}
                                                />
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">ご利用予定<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-radio">
                                                <p className="description">お客様提案の場合は、エンドユーザ様の会社名と住所をご相談内容に記載してください。</p>
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="youto_company" name="youto" value="1" checked={youto === "1"} onChange={handleYoutoChange} ref={youtoRef} />
                                                            <span
                                                                className="label">自社導入</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="youto_customer" name="youto" value="2" checked={youto === "2"} onChange={handleYoutoChange} />
                                                            <span
                                                                className="label">お客様提案</span>
                                                        </label>
                                                    </li>
                                                    <input type="hidden" style={{ display: "none" }}  {...register("youto", { required: "ご利用予定を選択してください。" })} />
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">ご導入予定時期<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-radio">
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="release_complete" name="release" value="1" checked={release === "1"} onChange={handleReleaseChange} ref={releaseRef} />
                                                            <span
                                                                className="label">導入済み</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="release_undef" name="release" value="2" checked={release === "2"} onChange={handleReleaseChange} />
                                                            <span
                                                                className="label">未定</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="release_3-months" name="release" value="3" checked={release === "3"} onChange={handleReleaseChange} />
                                                            <span
                                                                className="label">3ヶ月以内</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="release_6-months" name="release" value="4" checked={release === "4"} onChange={handleReleaseChange} />
                                                            <span
                                                                className="label">半年以内</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="release_12-months" name="release" value="5" checked={release === "5"} onChange={handleReleaseChange} />
                                                            <span
                                                                className="label">1年以内</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="release_12-months_over" name="release" value="6" checked={release === "6"} onChange={handleReleaseChange} />
                                                            <span
                                                                className="label">1年以上先</span>
                                                        </label>
                                                    </li>
                                                    <input type="hidden" style={{ display: "none" }}  {...register("release", { required: "ご導入予定時期を選択してください。" })} />
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>ご予算</b>
                                            </div>
                                        </td>
                                        <td>
                                            <ul className="list">
                                                <li>
                                                    <div className="mod-input-select">
                                                        <span className="wrap">
                                                            <select id="yosan" name="yosan" value={yosan ? yosan : ""} onChange={handleYosanChange}>
                                                                <option value="～100万円">～100万円</option>
                                                                <option value="～500万円">～500万円</option>
                                                                <option value="～1000万円">～1000万円</option>
                                                                <option value="1000万円～">1000万円～</option>
                                                            </select>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">正式会社名／団体名<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="text" id="cname" name="cname" maxLength="255" style={{ maxWidth: "60%" }} value={cname ? cname : ""} 
                                                onChange={handleCnameChange} placeholder="例：日本電気株式会社" ref={cnameRef} onBlur={handleCnameNormalize} />
                                                <input type="text" style={{ display: "none" }} id="cnameText"
                                                    {...register("cname", {
                                                        required: "貴方の会社名／団体名を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "貴方の会社名／団体名を入力してください。"
                                                        }
                                                    })}
                                                />
                                                <p className="description"><em>NEC社内/関連会社/販売店/パートナー様の方はご遠慮ください。</em></p>

                                                <div className="description">
                                                    <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                        <a href="https://www.pb.nec.co.jp/product/info/express5800/contact" target="_blank">
                                                            <img className="icn" lang="en" alt="popup" src={imageUrlBlank} />
                                                            販売店・パートナー様はこちら
                                                        </a>
                                                        <br />
                                                        <a href="https://one.nec.com/info/express5800/contact" target="_blank">
                                                            <img className="icn" lang="en" alt="popup" src={imageUrlBlank} />
                                                            NECグループの方はこちら
                                                        </a>
                                                    </b>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">ご所属</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="text" id="section" name="section" maxLength="255" style={{ maxWidth: "60%" }} value={section ? section : ""} 
                                                onChange={handleSectionChange} placeholder="例：ファーストコンタクトセンター" onBlur={handleSectionNormalize} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>お名前<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="listbox" id="name" name="name" maxLength="100" style={{ maxWidth: "60%" }}
                                                    placeholder="例：日電  太郎" value={name ? name : ""} onChange={handleNameChange} ref={nameRef} onBlur={handleNameNormalize} />
                                                <input type="text" style={{ display: "none" }} id="nameText"
                                                    {...register("name", {
                                                        required: "お名前を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "お名前を入力してください。"
                                                        }
                                                    })}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>ご住所<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-select">

                                                <label>
                                                    <b className="label">都道府県</b>
                                                    <span className="wrap">
                                                        <select id="ken" name="ken" value={ken ? ken : ""} onChange={handleKenChange}>
                                                            <option value="東京都">東京都</option>
                                                            <option value="北海道">北海道</option>
                                                            <option value="青森県">青森県</option>
                                                            <option value="秋田県">秋田県</option>
                                                            <option value="岩手県">岩手県</option>
                                                            <option value="山形県">山形県</option>
                                                            <option value="宮城県">宮城県</option>
                                                            <option value="福島県">福島県</option>
                                                            <option value="栃木県">栃木県</option>
                                                            <option value="群馬県">群馬県</option>
                                                            <option value="茨城県">茨城県 </option>
                                                            <option value="千葉県">千葉県</option>
                                                            <option value="埼玉県">埼玉県</option>
                                                            <option value="神奈川県">神奈川県</option>
                                                            <option value="山梨県">山梨県</option>
                                                            <option value="長野県">長野県</option>
                                                            <option value="新潟県">新潟県</option>
                                                            <option value="富山県">富山県</option>
                                                            <option value="石川県">石川県</option>
                                                            <option value="福井県">福井県</option>
                                                            <option value="静岡県">静岡県</option>
                                                            <option value="愛知県">愛知県</option>
                                                            <option value="岐阜県">岐阜県</option>
                                                            <option value="滋賀県">滋賀県</option>
                                                            <option value="三重県">三重県</option>
                                                            <option value="奈良県">奈良県</option>
                                                            <option value="和歌山県">和歌山県</option>
                                                            <option value="京都府">京都府</option>
                                                            <option value="大阪府">大阪府</option>
                                                            <option value="兵庫県">兵庫県</option>
                                                            <option value="鳥取県">鳥取県</option>
                                                            <option value="島根県">島根県</option>
                                                            <option value="岡山県">岡山県</option>
                                                            <option value="広島県">広島県</option>
                                                            <option value="山口県">山口県</option>
                                                            <option value="香川県">香川県</option>
                                                            <option value="愛媛県">愛媛県</option>
                                                            <option value="徳島県">徳島県</option>
                                                            <option value="高知県">高知県</option>
                                                            <option value="福岡県">福岡県</option>
                                                            <option value="佐賀県">佐賀県</option>
                                                            <option value="長崎県">長崎県</option>
                                                            <option value="熊本県">熊本県</option>
                                                            <option value="大分県">大分県</option>
                                                            <option value="宮崎県">宮崎県</option>
                                                            <option value="鹿児島県">鹿児島県</option>
                                                            <option value="沖縄県">沖縄県</option>
                                                            <option value="その他">その他</option>
                                                        </select>
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="mod-input">
                                                <p className="description">市区町村以降</p>
                                                <input type="text" id="address" name="address" maxLength="512" style={{ maxWidth: "95%" }}
                                                    placeholder="" value={address ? address : ""} onChange={handleAddressChange} ref={addressRef} onBlur={handleAddressNormalize} />
                                                <input type="text" style={{ display: "none" }} id="addressText"
                                                    {...register("address", {
                                                        required: "ご住所の市区町村以降を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "ご住所の市区町村以降を入力してください。"
                                                        }
                                                    })}
                                                />
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>お電話番号<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="listbox" id="tel1" name="tel1" maxLength="4" style={{ maxWidth: "20%" }}
                                                    placeholder="03" value={tel1 ? tel1 : ""} onChange={handleTel1Change} ref={tel1Ref} onBlur={handleTel1Normalize} />
                                                <input type="text" style={{ display: "none" }} id="addressText"
                                                    {...register("tel1", {
                                                        required: "お電話番号を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "お電話番号を入力してください。"
                                                        }
                                                    })}
                                                />
                                                <span className="label"> - </span>
                                                <input type="listbox" id="tel2" name="tel2" maxLength="4" style={{ maxWidth: "20%" }}
                                                    placeholder="1234" value={tel2 ? tel2 : ""} onChange={handleTel2Change} ref={tel2Ref} onBlur={handleTel2Normalize} />
                                                <input type="text" style={{ display: "none" }} id="addressText"
                                                    {...register("tel2", {
                                                        required: "お電話番号を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "お電話番号を入力してください。"
                                                        }
                                                    })}
                                                />
                                                <span className="label"> - </span>
                                                <input type="listbox" id="tel3" name="tel3" maxLength="4" style={{ maxWidth: "20%" }}
                                                    placeholder="5678" value={tel3 ? tel3 : ""} onChange={handleTel3Change} ref={tel3Ref} onBlur={handleTel3Normalize} />
                                                <input type="text" style={{ display: "none" }} id="addressText"
                                                    {...register("tel3", {
                                                        required: "お電話番号を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "お電話番号を入力してください。"
                                                        }
                                                    })}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>E-Mail<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <p className="description"><em>E-Mailアドレスは、お間違えのないようお願いいたします。</em></p>
                                                <input type="text" id="email" name="email" maxLength="2000" style={{ maxWidth: "95%" }}
                                                    placeholder="" value={email ? email : ""} onChange={handleEmailChange} ref={emailRef} onBlur={handleEmailNormalize} />
                                                <input type="text" style={{ display: "none" }} id="addressText"
                                                    {...register("email", {
                                                        required: "E-Mailを入力してください。",
                                                        pattern: {
                                                            value: /^[a-zA-Z0-9][\w\-\.]+\@\w[\w\-\.]+[a-zA-Z0-9]$/,
                                                            message: "E-Mailアドレスとして相応しくない形式または文字が入力されています。"
                                                        }
                                                    })}
                                                />
                                            </div>

                                            <div className="mod-input">
                                                <p className="description">確認のため、もう一度入力してください(コピー・貼り付けはしないでください)</p>
                                                <input type="text" id="email2" name="email2" maxLength="2000" style={{ maxWidth: "95%" }}
                                                    placeholder="" value={email2 ? email2 : ""} onChange={handleEmail2Change} ref={email2Ref} onBlur={handleEmail2Normalize} />
                                                <input type="text" style={{ display: "none" }} id="addressText"
                                                    {...register("email2", {
                                                        required: "E-Mail（確認欄）を入力してください。",
                                                        pattern: {
                                                            value: /.*\S.*/,
                                                            message: "E-Mail（確認欄）を入力してください。"
                                                        }
                                                    })}
                                                />
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>担当営業</b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <p className="description">ご担当させていただいている弊社もしくは販売店の担当営業がおわかりでしたらご記入をお願いいたします。</p>
                                                <p className="description">　</p>
                                                <p className="description"><strong>会社名</strong></p>
                                                <input type="text" id="ecname" name="ecname" maxLength="255" style={{ maxWidth: "60%" }}
                                                    placeholder="" value={ecname ? ecname : ""} onChange={handleEcnameChange} onBlur={handleEcnameNormalize} />
                                            </div>

                                            <div className="mod-input">
                                                <p className="description"><strong>所属</strong></p>
                                                <input type="text" id="esection" name="esection" maxLength="255" style={{ maxWidth: "60%" }}
                                                    placeholder="" value={esection ? esection : ""} onChange={handleEsectionChange} onBlur={handleEsectionNormalize} />
                                            </div>

                                            <div className="mod-input">
                                                <p className="description"><strong>担当者名</strong></p>
                                                <input type="text" id="ename" name="ename" maxLength="100" style={{ maxWidth: "60%" }}
                                                    placeholder="" value={ename ? ename : ""} onChange={handleEnameChange} onBlur={handleEnameNormalize} />
                                            </div>

                                            <div className="mod-input">
                                                <p className="description"><strong>電話番号</strong></p>
                                                <input type="text" id="etel" name="etel" maxLength="25" style={{ maxWidth: "60%" }}
                                                    placeholder="" value={etel ? etel : ""} onChange={handleEtelChange} onBlur={handleEtelNormalize} />
                                            </div>

                                            <div className="mod-input">
                                                <p className="description"><strong>E-Mail</strong></p>
                                                <input type="text" id="eemail" name="eemail" maxLength="2000" style={{ maxWidth: "95%" }}
                                                    placeholder="" value={eemail ? eemail : ""} onChange={handleEemailChange} onBlur={handleEemailNormalize} />
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>


                            </table>
                        </div>
                        <div className="mod-txt align-center mb-0">
                            <strong>本フォームは、SSLによりお客様の情報を保護しています。</strong>
                        </div>
                        <div className="mod-txt align-center">
                            <strong>下記「お問い合わせいただく前に」にご同意いただいた上でお問い合わせをお願いいたします。</strong>
                        </div>
                        <div className="mod-txt align-center">
                            「確認ページ」にて「送信」ボタンを押すまで、入力いただいた情報は送信されません。
                        </div>
                    </form>
                    <div id="anc-attention" style={{margin: "0px 0px 0px", display: "block"}}></div>
                    <div>
                        <div className="mod-btn of-list">
                            <div className="btn">
                                <button type="submit" id="btn-send" className="btn_default_select" onClick={handleSubmit(onSubmit, checkErrorIsExist() === true ? checkErrors(errors) : null)}>入力内容を確認する</button>
                            </div>
                        </div>
                    </div>
                    <h4 className="mod-hdg-l4-02 mb-15">
                        <span>お問い合わせいただく前に</span>
                    </h4>
                    <div className="mod-box">
                        <div className="mod-list mb-30">
                            <ul className="list">
                                <div className="mod-txt">
                                    <strong>本サービスのご利用にあたり</strong>
                                </div>
                                <li>
                                    <div className="mod-txt">
                                        本サービスはSOHO/法人のお客様を対象としており、個人用途での本サービスのご利用はご遠慮いただいております。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        お問い合わせ内容に関して、より適切な回答をさせていただくために弊社内の担当部署から、およびNECグループ会社、販売店から直接回答を差し上げることがあります。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        本フォームでいただいたお問い合わせ内容によっては、電話や書面にて回答させていただく場合があります。なお、ご要望に沿えない場合があります。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        弊社からお客様へ送信する電子メールは、お客様個人宛てにお送りするものです。回答の内容の一部または全部を転載したり、二次利用することはご遠慮ください。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        お客様からいただいたメールアドレスに誤りがあった場合やウィルスが検出された場合、システム障害などの場合には回答できない場合があります。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        土曜日、日曜日・祝日など弊社休業日にいただいたお問い合わせにつきましては、翌営業日以降の受付とさせていただきます。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        お問い合わせの内容が不適切な場合、またはお客様を特定出来ない場合は、弊社から連絡を差し上げないことがあります。
                                    </div>
                                </li>
                            </ul>
                            <br />
                            <ul className="list">
                                <div className="mod-txt">
                                    <strong>個人情報の取り扱いについて</strong>
                                </div>
                                <li>
                                    <div className="mod-txt">
                                        本ページは個人情報保護のため、SSL(Secure Socket Laver）暗号化通信に対応しています。 ご提供いただいた個人情報は、<a href="https://jpn.nec.com/site/privacy/index.html " target="_blank"><img className="icn" lang="en" alt="new window" src={imageUrlBlank} />「NEC個人情報保護方針」</a>に基づき適切な管理・保護に努めます。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        また、お問い合わせに関する回答や関連する商品・サービスに関する追加情報のご提供、およびより良い商品サービス開発のための調査・分析に利用するものとし、それ以外の目的には利用いたしません。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        本サービスのご提供にあたり、弊社が業務契約を締結している会社に当該業務の全部または一部を委託することがあります。その場合は、個人情報保護を義務付けるための契約を締結したうえで個人情報を預託し、必要かつ適切な管理監督を行ないます。
                                    </div>
                                </li>
                                <li>
                                    <div className="mod-txt">
                                        お客様ご自身の個人情報に関する照会や、訂正、追加または削除については、お客様ご本人からのご連絡をいただくことにより適宜対応させていただきます（ご連絡は本フォームをご利用ください）。
                                    </div>
                                </li>
                            </ul>
                            <br />
                                <div className="mod-txt">
                                    <strong>NEC ファーストコンタクトセンター 運営事務局</strong>
                                </div>
                                <a style={{ margin: 0, display: "block"}} href="#anc-top" className="align-right">ページの先頭へ戻る</a>
                         </div>

                    </div>
                </div>
            </div >
        </div >
    )
}

export default MainComponent;